import { render, staticRenderFns } from "./TopSliderBlock.vue?vue&type=template&id=0b56dec8&scoped=true&"
import script from "./TopSliderBlock.vue?vue&type=script&lang=js&"
export * from "./TopSliderBlock.vue?vue&type=script&lang=js&"
import style0 from "./TopSliderBlock.vue?vue&type=style&index=0&id=0b56dec8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b56dec8",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiLazyImg: require('/app/components/UI/UiLazyImg.vue').default,UiLazyVideo: require('/app/components/UI/UiLazyVideo.vue').default})
